module.exports = __webpack_public_path__ + "img/score7.ff784a3f.png";